<template>
    <app-layout>
        <template v-slot:header>
            <Header :title="$t('assessment_note_entry')"
                    :isColumns="false"
                    :isFilter="false"
            >
            </Header>
        </template>
        <template v-slot:header-mobile>
            <HeaderMobile :title="$t('assessment_note_entry')"
                          :isColumns="false"
                          :isFilter="false"
            >
            </HeaderMobile>
        </template>
        <div>
            <b-col v-if="!students.length && !isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                    <div class="d-flex flex-column align-items-center">
                        <i class="ri-information-line" style="font-size: 100px">
                        </i>
                        <p>
                            {{$t('Student Not Found')}}
                        </p>
                    </div>
            </b-col>
            <b-col v-else-if="isLoading" class="d-flex justify-content-center align-items-center" style="min-height: 400px">
                <b-spinner variant="primary" label="Loading..."></b-spinner>
            </b-col>
            <div v-else>
                <div class="d-flex  flex-column">
                    <div class="d-flex justify-content-start overflow-auto">
                        <div>
                            <b-table
                                responsive
                                bordered
                                :items="[sectionInformation]"
                                :fields="fields"
                                class="border "
                            ></b-table>
                        </div>
                    </div>
                </div>
                <b-table-simple class="border"  small caption-top responsive bordered>
                    <thead>
                    <tr>
                        <th rowspan="2" class="text-center justify-center width-30">#</th>
                        <th rowspan="2" class="text-center justify-center w-80">ID#</th>
                        <th rowspan="2" class="text-center justify-center">First Name</th>
                        <th rowspan="2" class="text-center justify-center">Last Name</th>
                        <th v-for="(assessment,key) in assessments" :key="'header-' + assessment.id" :colspan="assessments.length" class="border-bottom text-center" >
                            <div class="d-flex justify-content-center align-items-center mb-2">
                                <b-form-checkbox
                                    v-model="assessment.is_active"
                                    @change="handleSelectedHours(key)"
                                >
                                    <span >{{ assessment.name }}</span>
                                </b-form-checkbox>

                            </div>
                        </th>
                        <th class="text-center width-100">Final Score</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(student, index) in students" :key="student.id" class="align-middle text-center">
                        <td class="text-center justify-center">{{ index + 1 }}</td>
                        <td class="text-center justify-center">{{ student.student_number }}</td>
                        <td class="text-left justify-center">{{ student.name }}</td>
                        <td class="d-flex justify-content-between">
                            <span class="mr-1">{{student.surname}}</span>

                            <span>
                                  <b-button variant="success" v-b-tooltip.hover.top="'Comments'" v-if="student.comment"  @click="openCommentModal(student)"><i class="ri-message-2-line"></i></b-button>
                                  <b-button variant="secondary" v-b-tooltip.hover.top="'No Comments'" v-if="student.comment===null" @click="openCommentModal(student)"  ><i class="ri-message-line"></i></b-button>
                            </span>
                        </td>
                            <td :colspan="assessments.length" v-for="(assessment,key) in assessments" :key="key">
                                <b-form-input type="number" :disabled="!assessment.is_active"
                                              min="0"
                                              max="100"
                                              v-check-min-max-value
                                               v-if="selectedExams[assessment.id] && selectedExams[assessment.id][index]"
                                               v-model="selectedExams[assessment.id][index].score"  />
                            </td>
                        <td class="text-center"><b-form-input v-model="student.score" disabled></b-form-input></td>
                    </tr>
                    </tbody>
                    <b-tfoot>
                        <tr class="border">
                            <td colspan="4"></td>
                                <td :colspan="assessments.length" v-for="(assessment,key) in assessments" :key="'save-button-' + assessment.id + '-' + key" class="text-center">
                                    <b-button
                                        v-if="assessment.is_active"
                                        variant="success"
                                        size="sm"
                                        class="w-100"
                                        @click="saveAttendance(assessment,key)"
                                    >
                                        Save
                                    </b-button>
                                </td>
                        </tr>
                    </b-tfoot>

                </b-table-simple>
            </div>
            <CommonModal size="md" ref="commentModal" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    <div>{{$t('update')}}</div>
                </template>
                <template v-slot:CommonModalContent>
                    <div>
                        <UpdateComment :comment="comment" :formId="formId" v-if="formProgress==='comments_update'" @updateComment="hideModal"/>
                    </div>
                </template>
            </CommonModal>

        </div>
    </app-layout>
</template>
<script>
import EslAttendanceService from "@/services/EslAttendanceService";
import AssessmentBulkEntryServices from "@/services/AssessmentBulkEntryServices";
import EslInstructorService from "@/services/EslInstructorService";
import qs from "qs";
import UpdateComment from "@/modules/assessmentBulkEntry/pages/UpdateComment.vue";
export default {
    components: {UpdateComment},
    data() {
        return {
            comment: null,
            formProgress: null,
            students:[],
            formId:null,
            assessments: [],
            selectedExams:{},
            enteredExamsGrade:[],
            isLoading: false,
            sectionInformation:null,
            fields: [
                {
                    key: 'course_name',
                    label:this.$t('course_name'),
                },
                {
                    key: 'classroom_name',
                    label: this.$t('classroom'),
                },
                {
                    key: 'instructor_name',
                    label: this.$t('instructor_name'),
                },
                {
                    key: 'start_date',
                    label: this.$t('start_date'),
                },
                {
                    key: 'end_date',
                    label: this.$t('end_date'),
                },

            ],
        };
    },
    metaInfo() {
        return {
            title: this.$t('assessment_note_entry'),
        }
    },
    created() {
        this.getStudents();
    },
    methods: {
        formClear(){
          this.formProgress = null;
        },
        examOptions(){
          let newOptions = this.assessments.map(assessment => {
              return {
                  ...assessment,
                  is_active: false,
              }
          })
            this.assessments = newOptions
        },
        handleSelectedHours() {
            let count = 0;
            this.assessments.forEach(assessment => {
                if (assessment.is_active && count > 0) {
                    assessment.is_active = false;
                } else if (assessment.is_active) {
                    count += 1;
                }
            });
        },
        async getStudents() {
            this.isLoading = true;
            const config = {
                params: {
                    filter: {
                        id: this.$route.params.sessionId,
                    }
                },
                paramsSerializer: (params) => qs.stringify(params, { encode: false }),
            };
            const {id} =localStorage.getItem("user")?JSON.parse(localStorage.getItem("user")):null;
            const [attendanceConfigData, studentList, assessmentTypes,enteredExamGrade] = await Promise.all([
                EslInstructorService.getInstructorSession(id, config),
                EslAttendanceService.getStudentsInformation(this.$route.params.sessionId),
                AssessmentBulkEntryServices.assessmentBulkEntry(this.$route.params.sessionId),
                AssessmentBulkEntryServices.getAssessmentScoreById(this.$route.params.sessionId)
            ]);

            this.students = studentList.data.data;
            this.sectionInformation = attendanceConfigData.data.data[0];

            this.assessments = assessmentTypes.data.data;
            this.enteredExamGrade = enteredExamGrade.data?.data?.assessment_types??[];
            this.examOptions()
            this.initializeExamScore()

            this.isLoading = false;
        },
        initializeExamScore() {
            if (!this.assessments || !this.students) return;
            this.assessments.forEach(assessment => {
                this.$set(this.selectedExams, assessment.id, {});
                for (let i = 1; i <= this.assessments.length; i++) {
                    this.selectedExams[assessment.id]=this.students.map(student => ({
                        student_program_id: student.student_program_id,
                        score: null
                    }));
                }
            });
            if (this.enteredExamGrade) {
                Object.entries(this.enteredExamGrade).forEach(([evaluation_assessment_id, students]) => {
                    if (this.selectedExams[evaluation_assessment_id]){
                        students.scores.forEach(scores => {
                            const index  = this.selectedExams[evaluation_assessment_id].findIndex(student => student.student_program_id === scores.student_program_id);
                            if (index!==-1) {
                                this.selectedExams[evaluation_assessment_id][index] = scores;

                            }else{
                                this.selectedExams[evaluation_assessment_id].push(scores);
                            }
                        })
                    }
                })
            }
        },
        async saveAttendance(assessment) {
          if (!this.checkPermission('assessment_assessmentscoreupdateorcreate')){
            return  this.$toast.error(this.$t('unauthorized_operation'))
          }
            const formData = {
                evaluation_assessments_id: assessment.evaluation_assessments_id,
                session_id: this.$route.params.sessionId,
                scores: this.selectedExams[assessment.id]
            };
            try {
                await AssessmentBulkEntryServices.assessmentBulkEntrySave(formData);
                this.$toast.success('successful Grade entry');
                assessment.is_active=false;
                await this.getStudents();
            } catch (error) {
                this.showErrors(error);
            }
        },
        openCommentModal({id,comment}){
            this.formId=id
            this.comment=comment;
            this.formProgress="comments_update"
            this.$refs.commentModal.$refs.commonModal.show()
        },
        hideModal(){
            this.formId=null;
            this.formProgress=null
            this.$refs.commentModal.$refs.commonModal.hide()
            this.getStudents()
        }
    }
};
</script>
